import { ShieldCheck } from "lucide-react";
import { Reveal } from "./Reveal";

const VERIFY_URL = "https://www.nachi.org/verify?nachiid=NACHI26090103";

/**
 * InterNACHI CPI certification band — verified holder: Khalid Gaddur,
 * Fedari Building Inspection LLC (NACHI26090103, verifiable via VERIFY_URL).
 * Logos shown in original colours and proportions with generous whitespace.
 */
export default function Certification() {
  return (
    <section className="py-14 lg:py-16 bg-white border-b border-line" data-testid="certification-band">
      <div className="wrap">
        <Reveal>
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
            <a href={VERIFY_URL} target="_blank" rel="noopener noreferrer" className="flex-none p-4" aria-label="Verify Fedari's InterNACHI CPI certification" data-testid="cpi-seal">
              <img src="/images/internachi-cpi-seal.webp" alt="InterNACHI Certified Professional Inspector (CPI) seal" width="432" height="442"
                className="w-28 h-auto md:w-32" loading="lazy" decoding="async" />
            </a>
            <div className="flex-1 text-center md:text-left">
              <span className="eyebrow">Certified</span>
              <h2 className="text-[clamp(1.4rem,2.6vw,1.9rem)] mt-2 mb-2">Inspected by an InterNACHI® Certified Professional Inspector</h2>
              <p className="text-bodytext max-w-[56ch]">Our certified inspector helps you make informed property decisions — independent, documented and verified.</p>
              <a href={VERIFY_URL} target="_blank" rel="noopener noreferrer" data-testid="cpi-verify-link"
                className="inline-flex items-center gap-2 mt-3 text-blue font-semibold text-[0.9rem] hover:underline">
                <ShieldCheck size={16} /> Verify certification at nachi.org
              </a>
            </div>
            <a href={VERIFY_URL} target="_blank" rel="noopener noreferrer" className="flex-none p-3 border border-line rounded-xl bg-white" aria-label="Scan to verify certification" data-testid="cpi-qr">
              <img src="/images/internachi-verify-qr.webp" alt="QR code linking to Fedari's InterNACHI certification verification" width="301" height="310"
                className="w-16 h-auto" loading="lazy" decoding="async" />
              <span className="block text-center font-mono-jb text-[0.55rem] tracking-wider text-muted uppercase mt-1.5">Scan to verify</span>
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
